import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TAccessTime, TCondition, TFinancialRuleSet, TProduct, TPlan, TPartialPlan } from '../entities/subscription-settings.model';
import { Observable } from 'rxjs';

import { APP_CONFIG } from '@application/config';

@Injectable({ providedIn: 'root' })
export class SubscriptionService {
  private readonly http: HttpClient = inject(HttpClient);
  private readonly apiUrl = inject(APP_CONFIG).apiUrl.subscription_service;

  public getAllAccessTimes(): Observable<TAccessTime[]> {
    return this.http.get<TAccessTime[]>(`${this.apiUrl}/AccessTime`, { withCredentials: true });
  }

  public getAccessTimeById(id: string): Observable<TAccessTime> {
    return this.http.get<TAccessTime>(`${this.apiUrl}/AccessTime?id=${id}`, { withCredentials: true });
  }

  public addAccessTime(accessTime: Partial<TAccessTime>): Observable<TAccessTime> {
    return this.http.post<TAccessTime>(`${this.apiUrl}/AccessTime`, accessTime, { withCredentials: true });
  }

  public updateAccessTime(accessTime: Partial<TAccessTime>): Observable<TAccessTime> {
    return this.http.put<TAccessTime>(`${this.apiUrl}/AccessTime`, accessTime, { withCredentials: true });
  }

  public removeAccessTime(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/AccessTime?id=${id}`, { withCredentials: true });
  }

  public getAllProducts(): Observable<TProduct[]> {
    return this.http.options<TProduct[]>(`${this.apiUrl}/Product`, { withCredentials: true });
  }

  public getProductById(id: string): Observable<TProduct> {
    return this.http.get<TProduct>(`${this.apiUrl}/Product?id=${id}`, { withCredentials: true });
  }

  public addProduct(product: Partial<TProduct>): Observable<TProduct> {
    return this.http.post<TProduct>(`${this.apiUrl}/Product`, product, { withCredentials: true });
  }

  public updateProduct(product: Partial<TProduct>): Observable<TProduct> {
    return this.http.put<TProduct>(`${this.apiUrl}/Product`, product, { withCredentials: true });
  }

  public removeProduct(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/Product?id=${id}`, { withCredentials: true });
  }

  public conditionsSubscriptionsOdata(): Observable<any> {
    return this.http.options<any>(`${this.apiUrl}/Condition`, { withCredentials: true });
  }

  public getAllConditions(): Observable<TCondition[]> {
    return this.http.options<TCondition[]>(`${this.apiUrl}/Condition`, { withCredentials: true });
  }

  public getConditionById(id: string): Observable<TCondition> {
    return this.http.get<TCondition>(`${this.apiUrl}/Condition?id=${id}`, { withCredentials: true });
  }

  public addCondition(condition: Partial<TCondition>): Observable<TCondition> {
    return this.http.post<TCondition>(`${this.apiUrl}/Condition`, condition, { withCredentials: true });
  }

  public updateCondition(condition: Partial<TCondition>): Observable<TCondition> {
    return this.http.put<TCondition>(`${this.apiUrl}/Condition`, condition, { withCredentials: true });
  }

  public removeCondition(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/Condition?id=${id}`, { withCredentials: true });
  }

  public getAllFinancialRuleSets(): Observable<TFinancialRuleSet[]> {
    return this.http.options<TFinancialRuleSet[]>(`${this.apiUrl}/FinancialRuleSet`, { withCredentials: true });
  }

  public getFinancialRuleSetById(id: string): Observable<TFinancialRuleSet> {
    return this.http.get<TFinancialRuleSet>(`${this.apiUrl}/FinancialRuleSet?id=${id}`, { withCredentials: true });
  }

  public addFinancialRuleSet(financialRuleSet: Partial<TFinancialRuleSet>): Observable<TFinancialRuleSet> {
    return this.http.post<TFinancialRuleSet>(`${this.apiUrl}/FinancialRuleSet`, financialRuleSet, { withCredentials: true });
  }

  public updateFinancialRuleSet(financialRuleSet: Partial<TFinancialRuleSet>): Observable<TFinancialRuleSet> {
    return this.http.put<TFinancialRuleSet>(`${this.apiUrl}/FinancialRuleSet`, financialRuleSet, { withCredentials: true });
  }

  public removeFinancialRuleSet(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/FinancialRuleSet?id=${id}`, { withCredentials: true });
  }

  public getAllPlans(): Observable<TPartialPlan[]> {
    return this.http.options<TPartialPlan[]>(`${this.apiUrl}/Plan`, { withCredentials: true });
  }

  public getPlanById(id: string): Observable<TPlan> {
    return this.http.get<TPlan>(`${this.apiUrl}/Plan?id=${id}`, { withCredentials: true });
  }

  public addPlan(payload: Partial<TPlan>): Observable<TPlan> {
    return this.http.post<TPlan>(`${this.apiUrl}/Plan`, payload, { withCredentials: true });
  }

  public updatePlan(payload: Partial<TPlan>): Observable<TPlan> {
    return this.http.put<TPlan>(`${this.apiUrl}/Plan`, payload, { withCredentials: true });
  }

  public removePlan(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/Plan?id=${id}`, { withCredentials: true });
  }
}